import axios, { AxiosInstance } from 'axios';
import { getIdToken, isAuthenticated } from './auth';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

const api: AxiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Inject Cognito ID token into every request
api.interceptors.request.use((config) => {
  if (isAuthenticated()) {
    const token = getIdToken();
    if (token) {
      config.headers['Authorization'] = token;
    }
  }
  return config;
});

// Handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired — redirect to login
      localStorage.removeItem('auth_tokens');
      window.location.href = '/';
    }
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default api;
